var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AvailableTooltip } from '../../../components/other/AvailableTooltip';
let QuestionBarDifficulty = class QuestionBarDifficulty extends React.PureComponent {
    get popoverContent() {
        const { question } = this.props;
        const { difficulty } = question.questionInfo;
        if (difficulty > 0.9)
            return 'ultra schwierig';
        if (difficulty > 0.8)
            return 'extrem schwierig';
        if (difficulty > 0.7)
            return 'sehr schwierig';
        if (difficulty > 0.6)
            return 'schwierig';
        if (difficulty > 0.5)
            return 'ziemlich schwierig';
        if (difficulty > 0.4)
            return 'eher schwierig';
        if (difficulty > 0.3)
            return 'mittelschwer';
        if (difficulty > 0.25)
            return 'eher leicht';
        if (difficulty > 0.15)
            return 'leicht';
        if (difficulty > 0.1)
            return 'sehr leicht';
        return 'extrem leicht';
    }
    get tooltipTitle() {
        return `Diese Frage ist ${this.popoverContent}`;
    }
    render() {
        const { question } = this.props;
        if (!question)
            return null;
        return (React.createElement(AvailableTooltip, { title: this.tooltipTitle, placement: "left" },
            React.createElement("div", { onDoubleClick: () => alert(question.id), style: {
                    borderRadius: 0,
                    width: 120,
                    height: 10,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginBottom: 10,
                    background: 'linear-gradient(to right, rgba(165, 201, 86, 0.4) 0px, rgba(255, 191, 71, 0.4) 60px, rgba(218, 73, 73, 0.4) 120px)'
                } },
                React.createElement("div", { style: {
                        width: `${100 * question.questionInfo.difficulty}%`,
                        height: 10,
                        border: '1px solid rgba(0,0,0,0.3)',
                        borderRadius: 2,
                        background: 'linear-gradient(to right, #a5c956 0px, #ffbf47 60px, #da4949 120px)'
                    } }))));
    }
};
QuestionBarDifficulty = __decorate([
    observer
], QuestionBarDifficulty);
export { QuestionBarDifficulty };
